import script from "./MagicNinawitch.vue?vue&type=script&setup=true&lang=js"
export * from "./MagicNinawitch.vue?vue&type=script&setup=true&lang=js"

import "./MagicNinawitch.vue?vue&type=style&index=0&id=0ec25986&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ec25986"]])

export default __exports__